export default function setDateFromAction(dateFrom) {
    return {
        type: 'SET_DATEFROM',
        payload: dateFrom
    }
}
